// The exchange clocks — timezone arithmetic, and nothing else.
//
// ─── What used to be here, and why it is gone (2026-09-23) ───────────────────
// This module also decided whether each exchange was OPEN, from session
// boundaries hardcoded on 2026-07-30: TASE "Sun–Thu 09:59–17:14, Sunday ends
// 15:50" and NYSE "Mon–Fri 09:30–16:00". No source was ever cited for either.
//
// The TASE numbers had been wrong since 4 January 2026: the exchange moved to
// a Monday–Friday week that day (10:00–17:35 Mon–Thu, 10:00–13:50 Fri). The
// app therefore called Friday closed while it traded, and Sunday open while
// it did not — for nine months, with a confident dot beside it.
//
// That is the whole argument. A schedule nothing refreshes is a number with
// no source, it drifts silently, and "the market is open" is a claim about
// the world. Zero fabrication applies to it exactly as it applied to the TASE
// index rows that were removed for the same reason.
//
// The clocks stay: the time in Tel Aviv and in New York comes from the IANA
// timezone database through Intl, which IS a live source, updated with the
// browser. Wall-clock time is a fact; a session boundary was a guess.
//
// Bringing open/closed back needs a live source (an exchange-status endpoint),
// which is a new external surface and David's call.

const TZ_TLV = "Asia/Jerusalem";
const TZ_NY  = "America/New_York";

// "HH:MM" on that exchange's own clock, or "" when it cannot be computed —
// never the device clock, and never a hardcoded UTC offset (the inline
// versions this replaced used utcH+3 / utcH-4, correct only during DST).
export function zonedTime(timeZone) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone, hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).formatToParts(new Date());
    const pick = type => parts.find(p => p.type === type)?.value;
    const hour = pick("hour"), min = pick("minute");
    if (hour == null || min == null) return "";
    return `${hour}:${min}`;
  } catch {
    return "";
  }
}

export const tlvTime = () => zonedTime(TZ_TLV);
export const nyTime  = () => zonedTime(TZ_NY);
